import * as React from 'react';
import EventCommentAnswerCard from "./EventCommentAnswerCard";
import {useComments} from "./hooks/useComments";

const EventCommentAnswerList = ({contentId}) => {
    const {commentList} = useComments(contentId);
    return (
        <div>
            {
                commentList && commentList.slice(0).reverse().map((comment, i) => (
                    <div key={i}>
                        <EventCommentAnswerCard comment={comment} contentId={contentId}></EventCommentAnswerCard>
                    </div>
                ))
            }
        </div>
    )
}

export default EventCommentAnswerList;